import { useState, useEffect, useRef } from "react";

// ─── CONSTANTS ────────────────────────────────────────────────────
const DAYS = ['Maandag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag','Zondag'];
const DAYS_SHORT = ['Ma','Di','Wo','Do','Vr','Za','Zo'];

const DAILY_QUOTES = [
  { quote: "Ik ben trots op mezelf dat ik aan deze reis ben begonnen.", sub: "Jouw eerste stap telt." },
  { quote: "Consistentie is geen motivatie. Het is een beslissing.", sub: "Elke dag opnieuw kiezen voor jezelf." },
  { quote: "Je lichaam hoort je. Geef het de juiste boodschappen.", sub: "Voeding is informatie." },
  { quote: "Vooruitgang, geen perfectie. Elke stap in de goede richting telt.", sub: "Wees geduldig met jezelf." },
  { quote: "Je verdient energie, helderheid en een lichaam dat zich goed voelt.", sub: "Niet als beloning — gewoon omdat je het bent." },
  { quote: "Kleine keuzes, grote veranderingen. Één shake, één maaltijd, één dag.", sub: "Het begint hier." },
  { quote: "Luister naar je lichaam. Het vertelt je precies wat het nodig heeft.", sub: "Vertrouw het proces." },
  { quote: "Sterker dan gisteren. Zachter voor jezelf dan morgen.", sub: "Balans is geen eindpunt." },
  { quote: "Je gaat dit niet vergeten. Dit is het moment waarop alles begon te veranderen.", sub: "Onthoud hoe je je voelde op dag 1." },
  { quote: "Rust is ook werk. Herstel is ook prestatie.", sub: "Geef jezelf toestemming om te laden." },
];

const SHAKE_FLAVORS = ['Chocolade','Aardbei','Vanille','Vegan Chocolade','Vegan Aardbei','Winter Spice 🌿'];

const SNACK_DATA = [
  { name: '1 Snack Bites (kaneel)', icon: '🍪', why: '✅ Portiegecontroleerd, laag in suiker, hoog in vezels.', credits: 3 },
  { name: '½ IsaLean chocoladereep', icon: '🍫', why: '✅ ~12g eiwit per halve reep, laag in suiker.', credits: null },
  { name: '4-6 Isagenix snacks (bosbes)', icon: '🫐', why: '✅ Portiegecontroleerd, laag in suiker.', credits: 2 },
  { name: 'Een stuk fruit', icon: '🍎', why: '✅ Kies appel, peer, bessen, kiwi. Geen banaan/druiven.', credits: null },
  { name: 'Handje noten & zaden', icon: '🥜', why: '✅ Gezonde vetten + eiwit. ±20g, ongezouten.', credits: null },
  { name: 'Cracker met kwark', icon: '🫙', why: '✅ Complexe KH + eiwit. Geen zoete kwark!', credits: null },
  { name: 'Volkoren cracker + gerookte zalm', icon: '🐟', why: '✅ Eiwit + omega-3 + vezels. Topcombo.', credits: null },
  { name: 'Yoghurt met rode bessen', icon: '🍓', why: '✅ Probiotica + antioxidanten. Kies Griekse of Skyr.', credits: null },
  { name: '1 E-shot', icon: '⚡', why: '✅ Geen suiker. Goed bij een dipje.', credits: 2 },
];

const OBJECTIVES = [
  { id: 'gewicht', label: 'Gewicht verliezen', emoji: '⚖️' },
  { id: 'opgeblazen', label: 'Opgeblazen gevoel', emoji: '🫧' },
  { id: 'spijsvertering', label: 'Spijsvertering', emoji: '🌿' },
  { id: 'energie', label: 'Meer energie', emoji: '⚡' },
  { id: 'slaap', label: 'Beter slapen', emoji: '😴' },
  { id: 'stress', label: 'Stress verminderen', emoji: '🧘' },
  { id: 'hormonen', label: 'Hormonaal evenwicht', emoji: '🔄' },
  { id: 'huid', label: 'Betere huid', emoji: '✨' },
  { id: 'suiker', label: 'Suikerdrang', emoji: '🍬' },
  { id: 'spieren', label: 'Spiermassa', emoji: '💪' },
  { id: 'detox', label: 'Ontgiften', emoji: '🍃' },
  { id: 'focus', label: 'Mentale focus', emoji: '🧠' },
];

const CLEANSEDAY_CREDITS = [
  { credits: 0, items: ['Zwarte koffie', 'Groene/zwarte thee', 'Kruidenthee', 'Water'] },
  { credits: 1, items: ['Xango Reserva', 'Nootropic Elixir', 'BEA Biotics'] },
  { credits: 2, items: ['Isagenix Snacks (2 wafels)', 'e-Shot', 'Collagen Elixir', 'AMPED Nitro', 'AMPED Hydrate'] },
  { credits: 3, items: ['Harvest Thins', 'Snack Bites', 'Energy Bites'] },
];

const FAQ_SYSTEM = `Je bent een hulpzame assistent voor het Reset en Balance Programma van Sarah Liekens (@liekens_sarah), een Belgische fitnesscoach voor vrouwen 35+. Beantwoord vragen bondig in het Nederlands/Vlaams.
SHAKE DAGEN: Ochtend Ionix Supreme. Ontbijt shake + Thermo GX. Snack 10u. Middag (Balance=maaltijd/Reset=shake+ThermoGX). Snack 16u. Avond maaltijd 400-600 kcal. Slapengaan 2 IsaMove.
VASTENDAGEN: 1x Thermo GX ochtend. 4x Nourish for Life. Geen shakes/maaltijden. Max 10 credits. Slapengaan 2 IsaMove.
KOFFIE: Samen met ontbijt, melk mag, GEEN suiker. Vastendag: zwart = 0 credits.
Twijfel? wa.me/32491486550`;

const WELLNESS_LABELS = ['','😫 Heel slecht','😟 Slecht','😕 Matig','😐 Onder gemiddeld','😶 Gemiddeld','🙂 Redelijk','😊 Goed','😄 Heel goed','🤩 Super','⭐ Toppie!'];
const wColor = v => !v ? '#ddd' : v <= 3 ? '#e74c3c' : v <= 5 ? '#e67e22' : v <= 7 ? '#f1c40f' : '#27ae60';

const C = {
  teal: '#1a6b5a', tealLight: '#e6f2ef', tealMid: '#2d8a72',
  gold: '#c9a020', goldLight: '#fdf6e3',
  cream: '#faf7f2', dark: '#1c1c1c', muted: '#777', border: '#e0d8cc',
};
const ss = { width: '100%', border: `1px solid ${C.border}`, borderRadius: 7, padding: '7px 10px', fontSize: 13, background: 'white', fontFamily: 'inherit', cursor: 'pointer', outline: 'none' };
const is = { width: '100%', border: `1px solid ${C.border}`, borderRadius: 7, padding: '7px 10px', fontSize: 13, fontFamily: 'inherit', outline: 'none', background: 'white' };

const formatDate = (d) => d ? new Date(d).toLocaleDateString('nl-BE', { day: 'numeric', month: 'long', year: 'numeric' }) : '';
const addDays = (dateStr, n) => { const d = new Date(dateStr); d.setDate(d.getDate() + n); return d; };

function Lbl({ children, gold }) {
  return <div style={{ fontSize: 11, fontWeight: 700, color: gold ? C.gold : C.teal, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 3 }}>{children}</div>;
}
function FR({ label, value }) {
  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'baseline', flexWrap: 'wrap' }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: C.teal, textTransform: 'uppercase', letterSpacing: 0.4, whiteSpace: 'nowrap' }}>{label}</span>
      <span style={{ fontSize: 12, color: '#555', fontStyle: 'italic' }}>{value}</span>
    </div>
  );
}

// ─── INTAKE VALIDATION FLOW ───────────────────────────────────────
function IntakeFlow({ onComplete }) {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({ name: '', pakket: '', startDate: '', objectives: [], vastenDays: [] });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (step === 0 && !data.name.trim()) e.name = 'Vul je voornaam in.';
    if (step === 1 && !data.pakket) e.pakket = 'Kies je pakket.';
    if (step === 2 && !data.startDate) e.startDate = 'Kies je startdatum.';
    if (step === 3 && data.objectives.length === 0) e.objectives = 'Selecteer minstens 1 doelstelling.';
    if (step === 4 && data.vastenDays.length === 0) e.vasten = `Kies ${data.pakket === 'balance' ? '1 vastendag' : 'je vastendagen'} voor deze week.`;
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const next = () => { if (validate()) setStep(s => s + 1); };
  const back = () => { setErrors({}); setStep(s => s - 1); };

  const toggleObj = (id) => setData(d => ({ ...d, objectives: d.objectives.includes(id) ? d.objectives.filter(o => o !== id) : [...d.objectives, id] }));

  const toggleVastenDay = (i) => {
    const max = 1;
    const current = data.vastenDays;
    if (current.includes(i)) {
      setData(d => ({ ...d, vastenDays: d.vastenDays.filter(x => x !== i) }));
      return;
    }
    if (current.length >= max) { setErrors({ vasten: `Max 1 vastendag per week voor het ${data.pakket === 'balance' ? 'Balance' : 'Reset'} pakket.` }); return; }
    if ((i > 0 && current.includes(i - 1)) || (i < 6 && current.includes(i + 1))) {
      setErrors({ vasten: 'Geen 2 vastendagen na elkaar — je lichaam heeft herstel nodig.' }); return;
    }
    setErrors({});
    setData(d => ({ ...d, vastenDays: [...d.vastenDays, i].sort() }));
  };

  const endDate = data.startDate ? addDays(data.startDate, 29) : null;

  const STEPS = [
    { title: 'Welkom! 👋', sub: 'Even kennismaken' },
    { title: 'Jouw pakket', sub: 'Wat heb je gekozen?' },
    { title: 'Wanneer begin je?', sub: 'Startdatum' },
    { title: 'Jouw doelen', sub: 'Wat wil je bereiken?' },
    { title: 'Vastendag(en)', sub: 'Plan je rustdag(en) in' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(160deg, ${C.teal} 0%, ${C.tealMid} 50%, #f8edd0 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ background: 'white', borderRadius: 24, maxWidth: 480, width: '100%', boxShadow: '0 24px 64px rgba(0,0,0,0.18)', overflow: 'hidden' }}>
        {/* Progress bar */}
        <div style={{ height: 4, background: '#eee' }}>
          <div style={{ height: '100%', width: `${((step + 1) / (STEPS.length + 1)) * 100}%`, background: `linear-gradient(90deg, ${C.teal}, ${C.gold})`, transition: 'width 0.4s' }} />
        </div>

        {/* Step header */}
        <div style={{ background: C.teal, padding: '20px 28px 16px' }}>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 11, color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 4 }}>
            Stap {step + 1} van {STEPS.length}
          </div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 600, color: 'white' }}>{STEPS[step].title}</div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', marginTop: 2 }}>{STEPS[step].sub}</div>
        </div>

        <div style={{ padding: '24px 28px' }}>

          {/* STEP 0: Name */}
          {step === 0 && (
            <div>
              <div style={{ marginBottom: 20 }}>
                <Lbl>Jouw voornaam</Lbl>
                <input value={data.name} onChange={e => setData(d => ({ ...d, name: e.target.value }))}
                  onKeyDown={e => e.key === 'Enter' && next()}
                  placeholder="bv. Lisa"
                  autoFocus
                  style={{ ...is, fontSize: 18, padding: '12px 16px', border: `2px solid ${errors.name ? '#e74c3c' : C.border}` }} />
                {errors.name && <div style={{ color: '#e74c3c', fontSize: 12, marginTop: 5 }}>⚠️ {errors.name}</div>}
              </div>
              <div style={{ background: C.tealLight, borderRadius: 12, padding: '14px 16px', marginBottom: 4 }}>
                <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, color: C.teal, fontStyle: 'italic', lineHeight: 1.4 }}>
                  "Ik ben trots op mezelf dat ik aan deze reis ben begonnen."
                </div>
                <div style={{ fontSize: 12, color: C.muted, marginTop: 6 }}>— Dit programma is jouw eerste stap naar meer energie en balans.</div>
              </div>
            </div>
          )}

          {/* STEP 1: Pakket */}
          {step === 1 && (
            <div>
              <div style={{ fontSize: 14, color: C.muted, marginBottom: 16 }}>Hoi {data.name}! Welk pakket heb je gekozen?</div>
              {[
                { id: 'balance', icon: '⚖️', label: 'Balance', sub: '1 shake + 2 maaltijden per dag', detail: '1 vastendag per week', color: C.teal },
                { id: 'reset', icon: '⚡', label: 'Reset', sub: '2 shakes + 1 maaltijd per dag', detail: '1 vastendag per week', color: C.gold },
              ].map(p => (
                <div key={p.id} onClick={() => { setData(d => ({ ...d, pakket: p.id, vastenDays: [] })); setErrors({}); }}
                  style={{ border: `2px solid ${data.pakket === p.id ? p.color : C.border}`, borderRadius: 14, padding: '16px 18px', marginBottom: 10, cursor: 'pointer', background: data.pakket === p.id ? (p.id === 'balance' ? C.tealLight : C.goldLight) : 'white', transition: 'all 0.15s' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ fontSize: 28 }}>{p.icon}</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 700, fontSize: 16, color: data.pakket === p.id ? p.color : C.dark }}>{p.label}</div>
                      <div style={{ fontSize: 12, color: C.muted, marginTop: 1 }}>{p.sub}</div>
                      <div style={{ fontSize: 11, color: p.color, fontWeight: 600, marginTop: 2 }}>{p.detail}</div>
                    </div>
                    {data.pakket === p.id && <div style={{ width: 22, height: 22, borderRadius: '50%', background: p.color, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: 13, fontWeight: 700 }}>✓</div>}
                  </div>
                </div>
              ))}
              {errors.pakket && <div style={{ color: '#e74c3c', fontSize: 12, marginTop: 5 }}>⚠️ {errors.pakket}</div>}
            </div>
          )}

          {/* STEP 2: Start date */}
          {step === 2 && (
            <div>
              <div style={{ marginBottom: 18 }}>
                <Lbl>Startdatum programma</Lbl>
                <input type="date" value={data.startDate} onChange={e => setData(d => ({ ...d, startDate: e.target.value }))}
                  style={{ ...is, fontSize: 16, padding: '12px 16px', border: `2px solid ${errors.startDate ? '#e74c3c' : C.border}` }} />
                {errors.startDate && <div style={{ color: '#e74c3c', fontSize: 12, marginTop: 5 }}>⚠️ {errors.startDate}</div>}
              </div>
              {data.startDate && (
                <div style={{ display: 'flex', gap: 10 }}>
                  <div style={{ flex: 1, background: C.tealLight, borderRadius: 10, padding: '12px 14px', textAlign: 'center' }}>
                    <div style={{ fontSize: 10, color: C.teal, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>🚀 Start</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: C.teal, marginTop: 3 }}>{formatDate(data.startDate)}</div>
                  </div>
                  <div style={{ flex: 1, background: C.goldLight, borderRadius: 10, padding: '12px 14px', textAlign: 'center' }}>
                    <div style={{ fontSize: 10, color: C.gold, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>🏁 Dag 30</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: C.gold, marginTop: 3 }}>{formatDate(endDate)}</div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* STEP 3: Objectives */}
          {step === 3 && (
            <div>
              <div style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>Selecteer alles wat jou aanspreekt, {data.name}. Dit verschijnt dagelijks op je planningsblad.</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, marginBottom: 8 }}>
                {OBJECTIVES.map(obj => {
                  const active = data.objectives.includes(obj.id);
                  return (
                    <button key={obj.id} onClick={() => { toggleObj(obj.id); setErrors({}); }} style={{
                      padding: '8px 14px', borderRadius: 20, border: `2px solid ${active ? C.teal : C.border}`,
                      background: active ? C.tealLight : 'white', color: active ? C.teal : C.muted,
                      fontSize: 13, fontWeight: active ? 600 : 400, cursor: 'pointer', fontFamily: 'inherit',
                    }}>{obj.emoji} {obj.label}</button>
                  );
                })}
              </div>
              {errors.objectives && <div style={{ color: '#e74c3c', fontSize: 12, marginTop: 5 }}>⚠️ {errors.objectives}</div>}
              {data.objectives.length > 0 && <div style={{ fontSize: 12, color: C.teal, marginTop: 6 }}>✅ {data.objectives.length} geselecteerd</div>}
            </div>
          )}

          {/* STEP 4: Vasten days */}
          {step === 4 && (
            <div>
              <div style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>
                Kies 1 vastendag per week. Geen 2 dagen na elkaar.
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {DAYS.map((day, i) => {
                  const isSelected = data.vastenDays.includes(i);
                  const prevSel = data.vastenDays.includes(i - 1);
                  const nextSel = data.vastenDays.includes(i + 1);
                  const wouldBeConsecutive = !isSelected && (prevSel || nextSel);
                  const atMax = !isSelected && data.vastenDays.length >= (data.pakket === 'balance' ? 1 : 4);
                  const disabled = wouldBeConsecutive || atMax;
                  return (
                    <div key={i} onClick={() => !disabled && toggleVastenDay(i)} style={{
                      display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
                      border: `2px solid ${isSelected ? C.gold : disabled ? '#eee' : C.border}`,
                      borderRadius: 12, cursor: disabled ? 'not-allowed' : 'pointer',
                      background: isSelected ? C.goldLight : disabled ? '#fafafa' : 'white',
                      opacity: disabled ? 0.5 : 1, transition: 'all 0.15s',
                    }}>
                      <div style={{ width: 22, height: 22, border: `2px solid ${isSelected ? C.gold : '#ccc'}`, borderRadius: 5, background: isSelected ? C.gold : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        {isSelected && <span style={{ color: 'white', fontSize: 13, fontWeight: 700 }}>✓</span>}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 14, color: isSelected ? C.gold : C.dark }}>{day}</div>
                        {wouldBeConsecutive && <div style={{ fontSize: 11, color: '#aaa' }}>Niet mogelijk na een andere vastendag</div>}
                      </div>
                      {isSelected && <span style={{ fontSize: 12, color: C.gold, fontWeight: 600 }}>⚡ vastendag</span>}
                    </div>
                  );
                })}
              </div>
              {errors.vasten && <div style={{ color: '#e74c3c', fontSize: 12, marginTop: 8, background: '#ffeaea', borderRadius: 8, padding: '8px 12px' }}>⚠️ {errors.vasten}</div>}
            </div>
          )}

          {/* Navigation */}
          <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
            {step > 0 && (
              <button onClick={back} style={{ flex: 1, padding: '13px', borderRadius: 12, border: `1px solid ${C.border}`, background: 'white', cursor: 'pointer', fontSize: 14, color: C.muted, fontFamily: 'inherit' }}>
                ← Terug
              </button>
            )}
            {step < STEPS.length - 1 ? (
              <button onClick={next} style={{ flex: 2, padding: '13px', borderRadius: 12, border: 'none', background: C.teal, color: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 600, fontFamily: 'inherit' }}>
                Volgende →
              </button>
            ) : (
              <button onClick={() => { if (validate()) onComplete(data); }} style={{ flex: 2, padding: '13px', borderRadius: 12, border: 'none', background: `linear-gradient(135deg, ${C.teal}, ${C.gold})`, color: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 700, fontFamily: 'inherit' }}>
                🚀 Start mijn programma!
              </button>
            )}
          </div>
        </div>

        <div style={{ textAlign: 'center', padding: '0 0 16px', fontSize: 11, color: '#bbb' }}>
          @liekens_sarah
        </div>
      </div>
    </div>
  );
}

// ─── MEAL BUILDER MODAL ───────────────────────────────────────────
const DEFAULT_PROTEINS = [
  { name: 'Kipfilet', portion: '150g', kcal: 165, protein: 31, icon: '🍗', why: 'Mager, hoog in eiwit, verzadigt lang.' },
  { name: 'Zalm', portion: '130g', kcal: 195, protein: 26, icon: '🐟', why: 'Rijk aan omega-3, goed voor hormonen en huid.' },
  { name: 'Witte vis', portion: '180g', kcal: 140, protein: 30, icon: '🐠', why: 'Heel mager, hoog in eiwit.' },
  { name: 'Eieren (heel)', portion: '3 stuks', kcal: 210, protein: 18, icon: '🥚', why: 'Complete eiwitten + gezonde vetten.' },
  { name: 'Mager rundvlees', portion: '140g', kcal: 200, protein: 28, icon: '🥩', why: 'IJzerrijk, goed voor energie.' },
  { name: 'Kalkoenfilet', portion: '150g', kcal: 155, protein: 30, icon: '🦃', why: 'Magerer dan kip, helpt bij slaap.' },
  { name: 'Garnalen', portion: '180g', kcal: 120, protein: 26, icon: '🦐', why: 'Extreem mager, laag in calorieën.' },
  { name: 'Kwark (mager)', portion: '250g', kcal: 135, protein: 22, icon: '🥛', why: 'Langzame vertering, lang verzadigd.' },
  { name: 'Hüttenkäse', portion: '200g', kcal: 140, protein: 24, icon: '🧀', why: 'Laag in vet, hoog in eiwit.' },
  { name: 'Tofu (stevig)', portion: '200g', kcal: 145, protein: 16, icon: '🟨', why: 'Plantaardig eiwit.' },
];
const DEFAULT_VEGGIES = [
  { name: 'Broccoli', icon: '🥦', why: 'Vezels & vitamine C. Goed voor bloating.' },
  { name: 'Spinazie', icon: '🌿', why: 'IJzerrijk, anti-inflammatoir.' },
  { name: 'Courgette', icon: '🥒', why: 'Waterrijk, goed voor opgeblazen gevoel.' },
  { name: 'Paprika', icon: '🫑', why: 'Vol vitamine C.' },
  { name: 'Komkommer', icon: '🥒', why: 'Ontvochtigt, bijna geen calorieën.' },
  { name: 'Bloemkool', icon: '🥦', why: 'Laag in koolhydraten.' },
  { name: 'Cherrytomaatjes', icon: '🍅', why: 'Antioxidant.' },
  { name: 'Champignons', icon: '🍄', why: 'B-vitaminen voor energie.' },
  { name: 'Gemengde sla', icon: '🥗', why: 'Onbeperkt, nul calorieën.' },
  { name: 'Witloof', icon: '🌿', why: 'Prebiotisch, goed voor darmen.' },
  { name: 'Sperziebonen', icon: '🫘', why: 'Vezels + plantaardig eiwit.' },
];
const DEFAULT_CARBS = [
  { name: 'Quinoa', portion: '40g droog', kcal: 145, gi: 'Laag ⭐', icon: '🫘', why: 'Laagste GI. Bevat ook eiwit. Glutenvrij.' },
  { name: 'Boekweit', portion: '40g droog', kcal: 140, gi: 'Laag ⭐', icon: '🌾', why: 'Glutenvrij, hoog in magnesium. Ideaal voor hormoonbalans.' },
  { name: 'Basmatirijst (volkoren)', portion: '35g droog', kcal: 120, gi: 'Laag-gemiddeld', icon: '🍚', why: 'Stabiele bloedsuiker. Altijd droog afwegen!' },
  { name: 'Zoete aardappel', portion: '150g', kcal: 130, gi: 'Gemiddeld', icon: '🍠', why: 'Vol vezels en beta-caroteen. Stabiele energie.' },
  { name: 'Volkoren pasta', portion: '60g droog', kcal: 205, gi: 'Gemiddeld', icon: '🍝', why: 'Meer vezels dan witte pasta. Kook al dente voor lagere GI.' },
  { name: 'Geen koolhydraten', portion: '—', kcal: 0, gi: '—', icon: '🚫', why: 'Op rustdagen of voor sneller resultaat. Vervang door extra groenten.' },
];
const DEFAULT_FATS = [
  { name: 'Olijfolie (1 tl)', portion: '1 tl', kcal: 40, icon: '🫒', why: 'Hart-gezonde vetten. Max 1 tl.' },
  { name: 'Avocado (¼)', portion: '¼ avocado', kcal: 60, icon: '🥑', why: 'Gezonde vetten + vezels. Let op portie.' },
  { name: 'Geen extra vet', portion: '—', kcal: 0, icon: '🚫', why: 'Als proteïne al vet bevat.' },
];

function MealBuilderModal({ onClose, onSave, mealLabel, favorites, onSaveFavorite }) {
  const [protein, setProtein] = useState(null);
  const [veggies, setVeggies] = useState([]);
  const [carb, setCarb] = useState(null);
  const [fat, setFat] = useState(null);
  const [activeTab, setActiveTab] = useState('favorieten');
  const [showWhy, setShowWhy] = useState({});
  const [mealName, setMealName] = useState('');
  const [showSaveFav, setShowSaveFav] = useState(false);
  const [customProteins, setCustomProteins] = useState([]);
  const [customVeggies, setCustomVeggies] = useState([]);
  const [customCarbs, setCustomCarbs] = useState([]);
  const [newCustom, setNewCustom] = useState({ 
    protein: '', proteinKcal: '', proteinProt: '',
    veggie: '',
    carb: '', carbKcal: '', carbGI: 'Laag',
  });

  const allProteins = [...DEFAULT_PROTEINS, ...customProteins];
  const allVeggies = [...DEFAULT_VEGGIES, ...customVeggies];
  const allCarbs = [...DEFAULT_CARBS, ...customCarbs];

  const toggleVeg = (name) => setVeggies(p => p.includes(name) ? p.filter(x => x !== name) : [...p, name]);
  const toggleWhy = (key) => setShowWhy(p => ({ ...p, [key]: !p[key] }));
  const totalKcal = (protein?.kcal || 0) + (carb?.kcal || 0) + (fat?.kcal || 0);
  const totalProtein = protein?.protein || 0;

  const buildMealString = () => {
    const parts = [];
    if (protein) parts.push(`${protein.icon} ${protein.name} (${protein.portion})`);
    if (veggies.length) parts.push(`🥗 ${veggies.join(', ')}`);
    if (carb && carb.name !== 'Geen koolhydraten') parts.push(`${carb.icon} ${carb.name} (${carb.portion})`);
    if (fat && fat.name !== 'Geen extra vet') parts.push(`${fat.icon} ${fat.name} (${fat.portion})`);
    return parts.join(' + ');
  };

  const loadFavorite = (fav) => {
    setProtein(fav.protein || null); setVeggies(fav.veggies || []);
    setCarb(fav.carb || null); setFat(fav.fat || null);
    setMealName(fav.name || ''); setActiveTab('protein');
  };

  const addCustom = (type) => {
    const val = newCustom[type].trim(); if (!val) return;
    if (type === 'protein') {
      setCustomProteins(p => [...p, { 
        name: val, portion: 'naar keuze', 
        kcal: Number(newCustom.proteinKcal) || 0, 
        protein: Number(newCustom.proteinProt) || 0, 
        icon: '✏️', why: 'Eigen ingrediënt', custom: true 
      }]);
      setNewCustom(p => ({ ...p, protein: '', proteinKcal: '', proteinProt: '' }));
    }
    if (type === 'veggie') {
      setCustomVeggies(p => [...p, { name: val, icon: '✏️', why: 'Eigen groente', custom: true }]);
      setNewCustom(p => ({ ...p, veggie: '' }));
    }
    if (type === 'carb') {
      setCustomCarbs(p => [...p, { 
        name: val, portion: 'naar keuze', 
        kcal: Number(newCustom.carbKcal) || 0, 
        gi: newCustom.carbGI || 'Onbekend', 
        icon: '✏️', why: 'Eigen koolhydraat', custom: true 
      }]);
      setNewCustom(p => ({ ...p, carb: '', carbKcal: '', carbGI: 'Laag' }));
    }
  };

  const TABS = [
    { id: 'favorieten', label: '⭐ Favorieten' },
    { id: 'protein', label: '🍗 Proteïne' },
    { id: 'veggies', label: '🥦 Groenten' },
    { id: 'carbs', label: '🍚 KH' },
    { id: 'fat', label: '🫒 Vet' },
  ];

  const ItemRow = ({ item, isActive, onSelect, whyKey }) => (
    <div style={{ border: `2px solid ${isActive ? C.teal : C.border}`, borderRadius: 11, overflow: 'hidden', marginBottom: 6 }}>
      <div onClick={onSelect} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 13px', cursor: 'pointer', background: isActive ? C.tealLight : 'white' }}>
        <span style={{ fontSize: 20 }}>{item.icon || '✏️'}</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: 13, color: isActive ? C.teal : C.dark }}>{item.name}{item.custom ? ' ✏️' : ''}</div>
          <div style={{ fontSize: 11, color: C.muted }}>{item.portion}{item.kcal ? ` • ${item.kcal} kcal` : ''}{item.protein ? ` • ${item.protein}g eiwit` : ''}{item.gi && item.gi !== '—' ? ` • GI: ${item.gi}` : ''}</div>
        </div>
        <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
          {!item.custom && <button onClick={e => { e.stopPropagation(); toggleWhy(whyKey); }} style={{ fontSize: 10, background: '#f0f8f6', border: `1px solid ${C.border}`, borderRadius: 8, padding: '2px 7px', cursor: 'pointer', color: C.teal }}>Waarom?</button>}
          {isActive && <span style={{ color: C.teal, fontSize: 16, fontWeight: 700 }}>✓</span>}
        </div>
      </div>
      {showWhy[whyKey] && <div style={{ padding: '7px 13px', background: '#f0faf6', borderTop: '1px solid #c8e8d8', fontSize: 11, color: '#2d6a4a' }}>💡 {item.why}</div>}
    </div>
  );

  const CustomInput = ({ type, placeholder }) => {
    if (type === 'protein') return (
      <div style={{ marginTop: 8, padding: '10px 12px', background: '#f0f8f6', borderRadius: 10, border: `1px dashed ${C.teal}` }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: C.teal, marginBottom: 6 }}>➕ Eigen proteïne toevoegen</div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <input value={newCustom.protein} onChange={e => setNewCustom(p => ({ ...p, protein: e.target.value }))} placeholder="Naam (bv. Skyr)" style={{ ...is, flex: 2, minWidth: 100, fontSize: 12, padding: '5px 8px' }} />
          <input value={newCustom.proteinKcal} onChange={e => setNewCustom(p => ({ ...p, proteinKcal: e.target.value }))} placeholder="kcal" type="number" style={{ ...is, width: 60, fontSize: 12, padding: '5px 8px' }} />
          <input value={newCustom.proteinProt} onChange={e => setNewCustom(p => ({ ...p, proteinProt: e.target.value }))} placeholder="eiwit g" type="number" style={{ ...is, width: 70, fontSize: 12, padding: '5px 8px' }} />
          <button onClick={() => addCustom('protein')} disabled={!newCustom.protein.trim()} style={{ background: C.teal, color: 'white', border: 'none', borderRadius: 7, padding: '0 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>+ Voeg toe</button>
        </div>
      </div>
    );
    if (type === 'carb') return (
      <div style={{ marginTop: 8, padding: '10px 12px', background: '#f0f8f6', borderRadius: 10, border: `1px dashed ${C.teal}` }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: C.teal, marginBottom: 6 }}>➕ Eigen koolhydraat toevoegen</div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <input value={newCustom.carb} onChange={e => setNewCustom(p => ({ ...p, carb: e.target.value }))} placeholder="Naam (bv. Speltrijst)" style={{ ...is, flex: 2, minWidth: 100, fontSize: 12, padding: '5px 8px' }} />
          <input value={newCustom.carbKcal} onChange={e => setNewCustom(p => ({ ...p, carbKcal: e.target.value }))} placeholder="kcal" type="number" style={{ ...is, width: 60, fontSize: 12, padding: '5px 8px' }} />
          <select value={newCustom.carbGI} onChange={e => setNewCustom(p => ({ ...p, carbGI: e.target.value }))} style={{ ...ss, width: 100, fontSize: 12, padding: '5px 8px' }}>
            <option value="Laag ⭐">Laag GI ⭐</option>
            <option value="Laag-gemiddeld">Laag-gemiddeld</option>
            <option value="Gemiddeld">Gemiddeld</option>
            <option value="Hoog">Hoog</option>
          </select>
          <button onClick={() => addCustom('carb')} disabled={!newCustom.carb.trim()} style={{ background: C.teal, color: 'white', border: 'none', borderRadius: 7, padding: '0 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>+ Voeg toe</button>
        </div>
      </div>
    );
    return (
      <div style={{ display: 'flex', gap: 7, marginTop: 8, padding: '9px 11px', background: '#f8f8f8', borderRadius: 10, border: `1px dashed ${C.border}` }}>
        <input value={newCustom[type]} onChange={e => setNewCustom(p => ({ ...p, [type]: e.target.value }))}
          onKeyDown={e => e.key === 'Enter' && addCustom(type)}
          placeholder={placeholder} style={{ ...is, background: 'white', flex: 1, fontSize: 12, padding: '6px 10px' }} />
        <button onClick={() => addCustom(type)} style={{ background: C.teal, color: 'white', border: 'none', borderRadius: 7, padding: '0 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>+ Voeg toe</button>
      </div>
    );
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 20, maxWidth: 560, width: '100%', maxHeight: '93vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>

        {/* Header */}
        <div style={{ background: `linear-gradient(135deg, ${C.teal}, ${C.tealMid})`, padding: '16px 20px', borderRadius: '20px 20px 0 0', flexShrink: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 21, color: 'white', fontWeight: 600 }}>🍽️ Maaltijdbuilder</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.8)' }}>{mealLabel}</div>
            </div>
            <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.25)', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontSize: 15, color: 'white' }}>✕</button>
          </div>
          <input value={mealName} onChange={e => setMealName(e.target.value)}
            placeholder="Geef je maaltijd een naam... (optioneel)"
            style={{ marginTop: 10, width: '100%', background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.35)', borderRadius: 8, padding: '7px 12px', fontSize: 13, color: 'white', outline: 'none', fontFamily: 'inherit' }} />
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            {[{ label: 'Kcal', val: totalKcal || '—', ok: totalKcal >= 400 && totalKcal <= 600, target: '400–600' },
              { label: 'Eiwit', val: totalProtein ? `${totalProtein}g` : '—', ok: totalProtein >= 25, target: '≥25g' }].map(m => (
              <div key={m.label} style={{ flex: 1, background: 'rgba(255,255,255,0.15)', borderRadius: 9, padding: '7px 10px', textAlign: 'center' }}>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase' }}>{m.label}</div>
                <div style={{ fontSize: 18, fontWeight: 700, color: m.ok ? '#a8f5d0' : 'white' }}>{m.val}</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.6)' }}>doel: {m.target}</div>
              </div>
            ))}
            <div style={{ flex: 2, background: 'rgba(255,255,255,0.15)', borderRadius: 9, padding: '7px 10px' }}>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', marginBottom: 2 }}>Samenvatting</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.9)', lineHeight: 1.4 }}>{buildMealString() ? buildMealString().slice(0, 55) + (buildMealString().length > 55 ? '...' : '') : 'Nog niets geselecteerd'}</div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', borderBottom: `1px solid ${C.border}`, flexShrink: 0, overflowX: 'auto' }}>
          {TABS.map(t => <button key={t.id} onClick={() => setActiveTab(t.id)} style={{ flex: 1, minWidth: 70, padding: '10px 4px', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 500, background: activeTab === t.id ? C.tealLight : 'white', color: activeTab === t.id ? C.teal : C.muted, borderBottom: activeTab === t.id ? `2px solid ${C.teal}` : '2px solid transparent', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>{t.label}</button>)}
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '14px 18px' }}>
          {activeTab === 'favorieten' && (
            favorites.length === 0
              ? <div style={{ textAlign: 'center', padding: '32px 20px', color: C.muted }}>
                  <div style={{ fontSize: 36, marginBottom: 10 }}>⭐</div>
                  <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>Nog geen favorieten</div>
                  <div style={{ fontSize: 13 }}>Stel een maaltijd samen en sla op als favoriet.</div>
                  <button onClick={() => setActiveTab('protein')} style={{ marginTop: 16, background: C.teal, color: 'white', border: 'none', borderRadius: 10, padding: '10px 22px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>Maaltijd bouwen →</button>
                </div>
              : <div>
                  <div style={{ fontSize: 12, color: C.muted, marginBottom: 8 }}>Klik op een favoriet om hem te laden.</div>
                  {favorites.map((fav, idx) => (
                    <div key={idx} style={{ border: `1.5px solid ${C.border}`, borderRadius: 12, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>⭐ {fav.name}</div>
                        <div style={{ fontSize: 11, color: C.muted, marginTop: 2, lineHeight: 1.4 }}>{fav.mealString}</div>
                      </div>
                      <button onClick={() => loadFavorite(fav)} style={{ background: C.tealLight, color: C.teal, border: `1px solid ${C.teal}`, borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Laden</button>
                    </div>
                  ))}
                </div>
          )}
          {activeTab === 'protein' && (
            <div>
              <div style={{ fontSize: 12, color: C.muted, marginBottom: 8 }}>Kies 1 proteïnebron — richt op ≥25g eiwit.</div>
              {allProteins.map(p => <ItemRow key={p.name} item={p} isActive={protein?.name === p.name} onSelect={() => setProtein(p)} whyKey={'p_' + p.name} />)}
              <CustomInput type="protein" placeholder="➕ Eigen proteïne toevoegen..." />
            </div>
          )}
          {activeTab === 'veggies' && (
            <div>
              <div style={{ fontSize: 12, color: C.muted, marginBottom: 8 }}>Onbeperkt! Combineer wat je lekker vindt.</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 6 }}>
                {allVeggies.map(v => {
                  const active = veggies.includes(v.name);
                  return (
                    <div key={v.name} style={{ border: `2px solid ${active ? C.teal : C.border}`, borderRadius: 10, overflow: 'hidden' }}>
                      <div onClick={() => toggleVeg(v.name)} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 11px', cursor: 'pointer', background: active ? C.tealLight : 'white' }}>
                        <span style={{ fontSize: 18 }}>{v.icon}</span>
                        <div style={{ flex: 1, fontSize: 13, fontWeight: active ? 600 : 400, color: active ? C.teal : C.dark }}>{v.name}</div>
                        <button onClick={e => { e.stopPropagation(); toggleWhy('v_' + v.name); }} style={{ fontSize: 10, background: '#f0f8f6', border: 'none', borderRadius: 6, padding: '2px 5px', cursor: 'pointer', color: C.teal }}>?</button>
                      </div>
                      {showWhy['v_' + v.name] && <div style={{ padding: '5px 11px', background: '#f0faf6', borderTop: '1px solid #c8e8d8', fontSize: 11, color: '#2d6a4a' }}>💡 {v.why}</div>}
                    </div>
                  );
                })}
              </div>
              <CustomInput type="veggie" placeholder="➕ Eigen groente toevoegen..." />
            </div>
          )}
          {activeTab === 'carbs' && (
            <div>
              <div style={{ fontSize: 12, color: C.muted, marginBottom: 4 }}>Kies 1. Weeg altijd af! <span style={{ color: C.teal, fontWeight: 600 }}>⭐ = lage GI — beste keuze voor stabiele bloedsuiker.</span></div>
              {allCarbs.map(c => <ItemRow key={c.name} item={c} isActive={carb?.name === c.name} onSelect={() => setCarb(c)} whyKey={'c_' + c.name} />)}
              <CustomInput type="carb" placeholder="➕ Eigen koolhydraat toevoegen..." />
            </div>
          )}
          {activeTab === 'fat' && (
            <div>
              <div style={{ fontSize: 12, color: C.muted, marginBottom: 8 }}>Optioneel — vaak zit er al vet in je proteïne.</div>
              {DEFAULT_FATS.map(f => <ItemRow key={f.name} item={f} isActive={fat?.name === f.name} onSelect={() => setFat(f)} whyKey={'f_' + f.name} />)}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '12px 18px', borderTop: `1px solid ${C.border}`, flexShrink: 0 }}>
          {buildMealString()
            ? <div style={{ background: C.tealLight, borderRadius: 9, padding: '9px 13px', marginBottom: 10, fontSize: 13, color: C.teal }}>
                {mealName && <div style={{ fontWeight: 600, marginBottom: 2 }}>📌 {mealName}</div>}
                <div>{buildMealString()}{totalKcal > 0 && <span style={{ color: C.muted }}> — ±{totalKcal} kcal</span>}</div>
              </div>
            : <div style={{ background: '#f8f8f8', borderRadius: 9, padding: '9px 13px', marginBottom: 10, fontSize: 13, color: C.muted }}>Kies minimaal een proteïnebron...</div>
          }
          {showSaveFav
            ? <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <input value={mealName} onChange={e => setMealName(e.target.value)} placeholder="Naam voor dit favoriet..." style={{ ...is, flex: 1 }} />
                <button onClick={() => { if (protein) { onSaveFavorite({ name: mealName || buildMealString().slice(0, 30), protein, veggies, carb, fat, mealString: buildMealString() }); setShowSaveFav(false); }}} style={{ background: C.gold, color: 'white', border: 'none', borderRadius: 8, padding: '0 14px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>⭐ Opslaan</button>
                <button onClick={() => setShowSaveFav(false)} style={{ background: 'white', color: C.muted, border: `1px solid ${C.border}`, borderRadius: 8, padding: '0 10px', cursor: 'pointer' }}>✕</button>
              </div>
            : protein && <button onClick={() => setShowSaveFav(true)} style={{ width: '100%', background: C.goldLight, color: C.gold, border: `1px solid ${C.gold}`, borderRadius: 9, padding: '8px', cursor: 'pointer', fontSize: 12, fontWeight: 600, marginBottom: 8 }}>⭐ Opslaan als favoriet</button>
          }
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={onClose} style={{ flex: 1, padding: '10px', borderRadius: 10, border: `1px solid ${C.border}`, background: 'white', cursor: 'pointer', fontSize: 13, color: C.muted }}>Annuleren</button>
            <button onClick={() => { if (protein) { onSave(buildMealString(), mealName); onClose(); }}} disabled={!protein}
              style={{ flex: 2, padding: '10px', borderRadius: 10, border: 'none', background: protein ? C.teal : '#ccc', color: 'white', cursor: protein ? 'pointer' : 'not-allowed', fontSize: 13, fontWeight: 600 }}>
              ✓ {mealName ? `"${mealName}" opslaan` : 'Maaltijd opslaan'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── PWA INSTALL BANNER ───────────────────────────────────────────
function InstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
    const standalone = window.navigator.standalone;
    if (ios && !standalone) { setIsIOS(true); setShowIOS(true); }

    const handler = (e) => { e.preventDefault(); setDeferredPrompt(e); setShow(true); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (isIOS && showIOS) return (
    <div style={{ background: C.teal, color: 'white', padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13 }}>
      <span style={{ fontSize: 20, flexShrink: 0 }}>📲</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600 }}>Voeg toe aan je startscherm</div>
        <div style={{ fontSize: 12, opacity: 0.85, marginTop: 2 }}>Tik op <strong>Delen</strong> (📤) dan <strong>"Zet op beginscherm"</strong> — open als app!</div>
      </div>
      <button onClick={() => setShowIOS(false)} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: 18, cursor: 'pointer', padding: 0 }}>✕</button>
    </div>
  );

  if (!show) return null;
  return (
    <div style={{ background: C.teal, color: 'white', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10, fontSize: 13 }}>
      <span style={{ fontSize: 20 }}>📲</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600 }}>Installeer als app op je startscherm</div>
        <div style={{ fontSize: 12, opacity: 0.85 }}>Altijd snel beschikbaar, ook offline!</div>
      </div>
      <button onClick={async () => { deferredPrompt.prompt(); const { outcome } = await deferredPrompt.userChoice; if (outcome === 'accepted') setShow(false); }} style={{ background: 'white', color: C.teal, border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>Installeer</button>
      <button onClick={() => setShow(false)} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: 18, cursor: 'pointer', padding: 0 }}>✕</button>
    </div>
  );
}

// ─── VASTEN MODAL ─────────────────────────────────────────────────
function VastenModal({ onClose }) {
  const [used, setUsed] = useState([]);
  const total = used.reduce((s, item) => { for (const g of CLEANSEDAY_CREDITS) { if (g.items.includes(item)) return s + g.credits; } return s; }, 0);
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 20, maxWidth: 500, width: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        <div style={{ background: `linear-gradient(135deg, ${C.gold}, #e8b832)`, padding: '18px 22px', borderRadius: '20px 20px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, color: 'white', fontWeight: 600 }}>⚡ Cleanseday Tracker</div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.3)', border: 'none', borderRadius: '50%', width: 32, height: 32, cursor: 'pointer', fontSize: 16, color: 'white' }}>✕</button>
        </div>
        <div style={{ padding: '18px 22px' }}>
          <div style={{ background: C.goldLight, borderRadius: 12, padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
            <div><div style={{ fontSize: 12, color: C.muted }}>Gebruikte credits</div><div style={{ fontSize: 28, fontWeight: 700, color: total >= 9 ? '#e74c3c' : C.gold }}>{total}<span style={{ fontSize: 14, color: C.muted }}> / 10</span></div></div>
            <div style={{ flex: 1, height: 8, borderRadius: 4, background: '#eee', overflow: 'hidden' }}><div style={{ width: `${(total / 10) * 100}%`, height: '100%', background: total >= 9 ? '#e74c3c' : C.gold, transition: 'width 0.3s' }} /></div>
          </div>
          {CLEANSEDAY_CREDITS.map(group => (
            <div key={group.credits} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: C.teal, marginBottom: 6 }}>{group.credits === 0 ? '✅ Vrij (0 credits)' : `${group.credits} credit${group.credits > 1 ? 's' : ''} per portie`}</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {group.items.map(item => { const active = used.includes(item); return <button key={item} onClick={() => group.credits > 0 && setUsed(p => p.includes(item) ? p.filter(x => x !== item) : [...p, item])} style={{ padding: '5px 12px', borderRadius: 16, border: `1.5px solid ${active ? C.teal : C.border}`, background: active ? C.tealLight : '#fafafa', color: active ? C.teal : C.muted, fontSize: 12, fontWeight: active ? 600 : 400, cursor: group.credits > 0 ? 'pointer' : 'default', fontFamily: 'inherit' }}>{group.credits > 0 && (active ? '✓ ' : '+ ')}{item}</button>; })}
              </div>
            </div>
          ))}
          <div style={{ background: '#f0f8f6', borderRadius: 10, padding: '10px 14px', fontSize: 12, color: C.teal }}>💡 Cherrytomaatjes, komkommer en magere groentebouillon zijn altijd toegestaan.</div>
        </div>
      </div>
    </div>
  );
}

// ─── PRINT CALENDAR ───────────────────────────────────────────────
function PrintCalendar({ days, profile }) {
  const { pakket, clientName, weekLabel, startDate, objectives } = profile;
  const isBalance = pakket === 'balance';
  const activeObjs = OBJECTIVES.filter(o => objectives.includes(o.id));
  const endDate = startDate ? addDays(startDate, 29) : null;

  const CheckPrint = ({ label, sub, gold }) => (
    <div className="pcb-row">
      <div className={`pcb-box ${gold ? 'pcb-box-gold' : ''}`} />
      <div className="pcb-text">
        <span className="pcb-label">{label}</span>
        {sub && <span className="pcb-sub"> — {sub}</span>}
      </div>
    </div>
  );

  return (
    <div className="print-calendar">
      {/* COVER */}
      <div className="print-page cover-page">
        <div className="cover-bar" />
        <div className="cover-body">
          <div className="cover-logo">Reset &amp; Balance</div>
          <div className="cover-sub-logo">Persoonlijk weekprogramma</div>
          <div className="cover-divider" />
          <div className="cover-quote-big">"Ik ben trots op mezelf dat ik aan deze reis ben begonnen."</div>
          <div className="cover-meta">
            <div className="cover-meta-row"><span className="cover-meta-k">Naam</span><span className="cover-meta-v">{clientName || '____________________'}</span></div>
            <div className="cover-meta-row"><span className="cover-meta-k">Week</span><span className="cover-meta-v">{weekLabel || '____________________'}</span></div>
            <div className="cover-meta-row"><span className="cover-meta-k">Pakket</span><span className="cover-meta-v">{isBalance ? '⚖️ Balance' : '⚡ Reset'}</span></div>
            {startDate && <div className="cover-meta-row"><span className="cover-meta-k">Start</span><span className="cover-meta-v">{formatDate(startDate)}</span></div>}
            {endDate && <div className="cover-meta-row"><span className="cover-meta-k">Dag 30</span><span className="cover-meta-v">{formatDate(endDate)} 🏁</span></div>}
          </div>
          {activeObjs.length > 0 && (
            <div className="cover-obj-section">
              <div className="cover-obj-title">Mijn doelstellingen deze week</div>
              <div className="cover-obj-grid">
                {activeObjs.map(o => <div key={o.id} className="cover-obj-item"><div className="pcb-box" style={{ width: 14, height: 14 }} /><span>{o.emoji} {o.label}</span></div>)}
              </div>
            </div>
          )}
        </div>
        <div className="cover-footer">@liekens_sarah • instagram.com/liekens_sarah • wa.me/32491486550</div>
      </div>

      {/* ONE PAGE PER DAY */}
      {days.map((day, i) => {
        const isVasten = day.type === 'vasten';
        const q = DAILY_QUOTES[i % DAILY_QUOTES.length];
        return (
          <div key={i} className="print-page day-page">
            <div className={`day-band ${isVasten ? 'band-gold' : 'band-teal'}`}>
              <div style={{ flexShrink: 0 }}>
                <div className="day-name-big">{day.name}</div>
                <div className="day-badge">{isVasten ? '⚡ Vastendag' : '🥤 Shake dag'}</div>
              </div>
              <div className="day-quote-inline">
                <div className="day-quote-inline-text">"{q.quote}"</div>
                <div className="day-quote-inline-sub">{clientName}, {q.sub}</div>
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div className="day-week-txt">{weekLabel || ''}</div>
              </div>
            </div>

            <div className="day-body">
              {/* LEFT: Protocol checklist */}
              <div className="day-col day-left">
                <div className="col-section-title">{isVasten ? '⚡ Vastendag protocol' : '🥤 Shake dag protocol'}</div>

                {!isVasten ? (<>
                  <CheckPrint label="Ionix Supreme 30ml" sub="Ochtend voor ontbijt" />
                  <CheckPrint label={`Shake ${day.shakeFlavor1}`} sub="Ontbijt + Thermo GX" />
                  <CheckPrint label={day.snack10u !== '— Kies snack —' ? day.snack10u : 'Snack'} sub="10u" />
                  {isBalance
                    ? <CheckPrint label={day.maaltijd1Name || 'Middagmaaltijd'} sub={day.maaltijd1 || '400–600 kcal'} />
                    : <CheckPrint label={`Shake ${day.shakeFlavor2}`} sub="Middag + Thermo GX" />
                  }
                  <CheckPrint label={day.snack16u !== '— Kies snack —' ? day.snack16u : 'Snack'} sub="16u" />
                  <CheckPrint label={day.maaltijd2Name || 'Avondmaaltijd'} sub={day.maaltijd2 || '400–600 kcal'} />
                  <CheckPrint label="2x IsaMove" sub="Slapengaan" />
                  <CheckPrint label="2–3 liter water" sub="Verspreid over de dag" />
                </>) : (<>
                  <CheckPrint label="Ionix Supreme 30ml" gold />
                  <CheckPrint label="1x Thermo GX" sub="Enkel in de ochtend" gold />
                  <div className="mini-section-title">Nourish for Life — 4x aanvinken</div>
                  <CheckPrint label="Nourish for Life" sub="☀️ Ochtend" gold />
                  <CheckPrint label="Nourish for Life" sub="🌤 Middag" gold />
                  <CheckPrint label="Nourish for Life" sub="🌆 Namiddag" gold />
                  <CheckPrint label="Nourish for Life" sub="🌙 Avond" gold />
                  <CheckPrint label="2x IsaMove" sub="Slapengaan" gold />
                  <CheckPrint label="2–3 liter water" gold />
                  {isVasten && (
                    <>
                      <div className="mini-section-title">Credits (max 10)</div>
                      <div className="credits-print-row">
                        {[1,2,3,4,5,6,7,8,9,10].map(n => <div key={n} className={`credit-box-print ${day.credits >= n ? 'credit-used' : ''}`}>{n}</div>)}
                      </div>
                      <div className="mini-section-title">Toegestane snacks</div>
                      <div className="allowed-print">{day.vastenSnack || 'Cherrytomaatjes • komkommer • bouillon'}</div>
                    </>
                  )}
                </>)}
                {day.notities && <div className="notes-print"><strong>Notities:</strong> {day.notities}</div>}
              </div>

              {/* RIGHT: Scores */}
              <div className="day-col day-right">
                <div className="col-section-title">Hoe voel ik me vandaag?</div>
                <div className="score-section">
                  <div className="score-label-row"><span>Energie algemeen</span><span className="score-val-print">{day.wellness > 0 ? `${day.wellness}/10` : '—/10'}</span></div>
                  <div className="score-boxes-print">
                    {[1,2,3,4,5,6,7,8,9,10].map(n => (
                      <div key={n} className="score-box-print" style={day.wellness >= n ? { background: wColor(day.wellness), color: 'white', border: 'none' } : {}}>{n}</div>
                    ))}
                  </div>
                </div>

                {activeObjs.length > 0 && (
                  <>
                    <div className="col-section-title" style={{ marginTop: 14 }}>Score per doelstelling</div>
                    {activeObjs.map(o => (
                      <div key={o.id} className="score-section">
                        <div className="score-label-row"><span>{o.emoji} {o.label}</span><span className="score-val-print">—/10</span></div>
                        <div className="score-boxes-print">
                          {[1,2,3,4,5,6,7,8,9,10].map(n => <div key={n} className="score-box-print">{n}</div>)}
                        </div>
                      </div>
                    ))}
                  </>
                )}

                <div className="col-section-title" style={{ marginTop: 14 }}>Water 💧</div>
                <div className="water-print-row">
                  {[1,2,3,4,5,6,7,8].map(n => <div key={n} className="water-print-glass"><div className="water-print-icon">🥤</div><div className="water-print-check" /></div>)}
                </div>
                <div className="water-print-label">250ml per glas — doel: 8 glazen</div>

                <div className="col-section-title" style={{ marginTop: 14 }}>Beweging</div>
                <div className="pcb-row"><div className="pcb-box" /><div className="pcb-text"><span className="pcb-label">Workout gedaan</span></div></div>
                <div className="pcb-row"><div className="pcb-box" /><div className="pcb-text"><span className="pcb-label">Stappen doel gehaald</span></div></div>

                <div className="day-mini-quote-print">
                  <div className="day-mini-q-txt">"{q.quote}"</div>
                  <div className="day-mini-q-sub">{q.sub}</div>
                </div>
              </div>
            </div>
            <div className="day-footer-print">@liekens_sarah • wa.me/32491486550</div>
          </div>
        );
      })}
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────
export default function App() {
  const [profile, setProfile] = useState(null);
  const [tab, setTab] = useState('planner'); // 'planner' | 'faq'
  const [showVastenModal, setShowVastenModal] = useState(false);
  const [mealModal, setMealModal] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [days, setDays] = useState(DAYS.map((name, i) => ({
    name, type: 'shake', wellness: 0,
    shakeFlavor1: 'Chocolade', // ontbijt shake
    shakeFlavor2: 'Chocolade', // middag shake
    shakeFlavor3: 'Chocolade', // avond shake (zelden)
    middagType: 'shake', avondType: 'maaltijd', // toggle per cel
    snack10u: '— Kies snack —', snack10uCustom: '',
    snack16u: '— Kies snack —', snack16uCustom: '',
    maaltijd1: '', maaltijd1Name: '',
    maaltijd2: '', maaltijd2Name: '',
    credits: 0, vastenSnack: '', notities: '',
  })));
  const [faqMsgs, setFaqMsgs] = useState([{ role: 'assistant', content: 'Hallo! 👋 Stel gerust je vragen over het programma!' }]);
  const [faqInput, setFaqInput] = useState('');
  const [faqLoading, setFaqLoading] = useState(false);
  const chatRef = useRef(null);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=DM+Sans:wght@300;400;500;600&display=swap';
    document.head.appendChild(link);
  }, []);
  useEffect(() => { if (chatRef.current) chatRef.current.scrollTop = chatRef.current.scrollHeight; }, [faqMsgs]);

  const handleIntakeComplete = (data) => {
    const updatedDays = days.map((d, i) => ({
      ...d,
      type: data.vastenDays.includes(i) ? 'vasten' : 'shake',
    }));
    setDays(updatedDays);
    setProfile({ ...data, weekLabel: '' });
  };

  const upd = (i, f, v) => setDays(p => p.map((d, idx) => idx === i ? { ...d, [f]: v } : d));
  const saveFavorite = (fav) => setFavorites(p => [...p.filter(f => f.name !== fav.name), fav]);

  const sendFaq = async () => {
    if (!faqInput.trim() || faqLoading) return;
    const msg = faqInput.trim(); setFaqInput('');
    const msgs = [...faqMsgs, { role: 'user', content: msg }]; setFaqMsgs(msgs); setFaqLoading(true);
    try {
      const res = await fetch('/.netlify/functions/chat', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ model: 'claude-sonnet-4-20250514', max_tokens: 1000, system: FAQ_SYSTEM, messages: msgs.filter((m, i) => !(m.role === 'assistant' && i === 0)).map(m => ({ role: m.role, content: m.content })) }) });
      const data = await res.json();
      setFaqMsgs(p => [...p, { role: 'assistant', content: data.content?.[0]?.text || 'Fout.' }]);
    } catch { setFaqMsgs(p => [...p, { role: 'assistant', content: 'Verbindingsfout.' }]); }
    setFaqLoading(false);
  };

  if (!profile) return <IntakeFlow onComplete={handleIntakeComplete} />;

  const endDate = profile.startDate ? addDays(profile.startDate, 29) : null;

  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif", background: C.cream, minHeight: '100vh', color: C.dark }}>
      <style>{`
        @media screen { .print-calendar { display: none !important; } }
        @media print {
          * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; box-sizing: border-box; }
          body { margin: 0; padding: 0; background: white !important; font-family: 'DM Sans', sans-serif; }
          .no-print { display: none !important; }
          .print-calendar { display: block !important; }
          .print-page { page-break-after: always; width: 210mm; min-height: 297mm; position: relative; }
          .print-page:last-child { page-break-after: avoid; }

          /* Cover */
          .cover-page { display: flex; flex-direction: column; }
          .cover-bar { height: 8px; background: linear-gradient(90deg, #1a6b5a, #2d8a72, #c9a020); }
          .cover-body { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px 50px; text-align: center; }
          .cover-logo { font-family: 'Cormorant Garamond', serif; font-size: 52px; font-weight: 600; color: #1a6b5a; letter-spacing: 2px; }
          .cover-sub-logo { font-size: 12px; color: #999; text-transform: uppercase; letter-spacing: 3px; margin-top: 6px; }
          .cover-divider { width: 60px; height: 3px; background: #c9a020; border-radius: 2px; margin: 22px auto; }
          .cover-quote-big { font-family: 'Cormorant Garamond', serif; font-size: 20px; font-style: italic; color: #2d6a5a; max-width: 380px; line-height: 1.5; margin-bottom: 32px; }
          .cover-meta { background: #f8f5f0; border-radius: 12px; padding: 18px 28px; width: 100%; max-width: 400px; text-align: left; }
          .cover-meta-row { display: flex; gap: 12px; align-items: baseline; padding: 6px 0; border-bottom: 1px solid #e8e0d4; }
          .cover-meta-row:last-child { border-bottom: none; }
          .cover-meta-k { font-size: 10px; font-weight: 700; color: #1a6b5a; text-transform: uppercase; letter-spacing: 0.5px; min-width: 65px; }
          .cover-meta-v { font-size: 14px; color: #1c1c1c; font-weight: 500; }
          .cover-obj-section { margin-top: 24px; width: 100%; max-width: 400px; text-align: left; }
          .cover-obj-title { font-size: 10px; font-weight: 700; color: #1a6b5a; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 8px; }
          .cover-obj-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 6px; }
          .cover-obj-item { display: flex; align-items: center; gap: 7px; font-size: 12px; color: #333; }
          .cover-footer { text-align: center; font-size: 9px; color: #bbb; padding: 14px; border-top: 1px solid #eee; }

          /* Day page */
          .day-page { display: flex; flex-direction: column; }
          .day-band { display: flex; justify-content: space-between; align-items: center; padding: 14px 22px; gap: 16px; }
          .day-quote-inline { flex: 1; text-align: center; padding: 0 16px; }
          .day-quote-inline-text { font-family: 'Cormorant Garamond', serif; font-size: 15px; font-style: italic; color: rgba(255,255,255,0.95); line-height: 1.4; font-weight: 600; }
          .day-quote-inline-sub { font-size: 10px; color: rgba(255,255,255,0.75); margin-top: 3px; }
          .band-teal { background: #1a6b5a; }
          .band-gold { background: #c9a020; }
          .day-name-big { font-family: 'Cormorant Garamond', serif; font-size: 34px; font-weight: 600; color: white; line-height: 1; }
          .day-badge { display: inline-block; margin-top: 4px; font-size: 11px; color: rgba(255,255,255,0.85); background: rgba(255,255,255,0.18); border-radius: 10px; padding: 2px 10px; font-weight: 600; }
          .day-week-txt { font-size: 12px; color: rgba(255,255,255,0.7); }
          .day-client-txt { font-size: 14px; font-weight: 600; color: white; margin-top: 2px; }
          .day-quote-bar { background: #f8f5f0; padding: 7px 20px; border-bottom: 1px solid #ece8e0; }
          .day-quote-t { font-family: 'Cormorant Garamond', serif; font-size: 12px; font-style: italic; color: #1a6b5a; }
          .day-quote-s { font-size: 10px; color: #999; }

          .day-body { flex: 1; display: flex; }
          .day-col { padding: 16px 18px; }
          .day-left { flex: 1.1; border-right: 1.5px solid #e8e0d4; }
          .day-right { flex: 1; }

          .col-section-title { font-size: 9px; font-weight: 700; color: #1a6b5a; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1.5px solid #d4ece5; }
          .mini-section-title { font-size: 8px; font-weight: 700; color: #999; text-transform: uppercase; letter-spacing: 0.5px; margin: 7px 0 4px; }

          /* Checkboxes */
          .pcb-row { display: flex; align-items: flex-start; gap: 7px; margin-bottom: 6px; }
          .pcb-box { width: 15px; height: 15px; border: 1.5px solid #1a6b5a; border-radius: 3px; flex-shrink: 0; margin-top: 1px; background: white; }
          .pcb-box-gold { border-color: #c9a020; }
          .pcb-text { flex: 1; }
          .pcb-label { font-size: 12px; font-weight: 500; color: #1c1c1c; }
          .pcb-sub { font-size: 10px; color: #888; }

          /* Credits */
          .credits-print-row { display: flex; gap: 3px; margin-bottom: 4px; }
          .credit-box-print { width: 17px; height: 17px; border: 1px solid #ddd; border-radius: 3px; font-size: 8px; display: flex; align-items: center; justify-content: center; color: #bbb; }
          .credit-used { background: #c9a020; color: white; border-color: #c9a020; }
          .allowed-print { font-size: 11px; color: #555; background: #fffbe6; border-radius: 5px; padding: 5px 8px; border: 1px solid #f0e0a0; }
          .notes-print { font-size: 10px; color: #777; font-style: italic; margin-top: 8px; padding-top: 6px; border-top: 1px dashed #ddd; }

          /* Score boxes */
          .score-section { margin-bottom: 8px; }
          .score-label-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 3px; font-size: 11px; font-weight: 500; color: #333; }
          .score-val-print { font-size: 11px; font-weight: 700; color: #555; }
          .score-boxes-print { display: flex; gap: 2px; }
          .score-box-print { width: 18px; height: 18px; border: 1.5px solid #ddd; border-radius: 4px; font-size: 8px; display: flex; align-items: center; justify-content: center; color: #bbb; }

          /* Water */
          .water-print-row { display: flex; gap: 5px; flex-wrap: wrap; margin-bottom: 3px; }
          .water-print-glass { display: flex; flex-direction: column; align-items: center; gap: 2px; }
          .water-print-icon { font-size: 14px; }
          .water-print-check { width: 15px; height: 15px; border: 1.5px solid #4a9bb8; border-radius: 3px; background: white; }
          .water-print-label { font-size: 9px; color: #aaa; }

          /* Mini quote */
          .day-mini-quote-print { margin-top: 14px; font-family: 'Cormorant Garamond', serif; color: #1a6b5a; text-align: center; padding: 9px 11px; border: 1px solid #d4ece5; border-radius: 8px; background: #f0f8f5; }
          .day-mini-q-txt { font-size: 12px; font-style: italic; line-height: 1.4; }
          .day-mini-q-sub { font-size: 9px; color: #999; margin-top: 3px; }

          .day-footer-print { text-align: center; font-size: 9px; color: #bbb; padding: 8px; border-top: 1px solid #eee; }
        }
        * { box-sizing: border-box; }
        input:focus, select:focus, textarea:focus { outline: 2px solid ${C.teal}; outline-offset: 1px; }
        button { font-family: inherit; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* Print calendar (hidden on screen) */}
      <PrintCalendar days={days} profile={{ ...profile, clientName: profile.name }} />

      {mealModal && (
        <MealBuilderModal
          mealLabel={mealModal.label}
          onClose={() => setMealModal(null)}
          favorites={favorites}
          onSaveFavorite={saveFavorite}
          onSave={(meal, name) => {
            upd(mealModal.dayIndex, mealModal.mealKey, meal);
            if (name) upd(mealModal.dayIndex, mealModal.mealNameKey, name);
            setMealModal(null);
          }}
        />
      )}

      {showVastenModal && <VastenModal onClose={() => setShowVastenModal(false)} />}

      {/* PWA install banner */}
      <InstallBanner />

      {/* HEADER */}
      <div className="no-print" style={{ background: C.teal, color: 'white', padding: '12px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, position: 'sticky', top: 0, zIndex: 9 }}>
        <div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 600, letterSpacing: 1 }}>Reset & Balance</div>
          <div style={{ fontSize: 11, opacity: 0.7 }}>Welkom, {profile.name} 👋 • {profile.pakket === 'balance' ? '⚖️ Balance' : '⚡ Reset'}</div>
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {[['planner','📋 Planning'],['workouts','💪 Workouts'],['faq','💬 FAQ']].map(([t, label]) => (
            <button key={t} onClick={() => setTab(t)} style={{ padding: '6px 14px', borderRadius: 16, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 500, background: tab === t ? 'white' : 'rgba(255,255,255,0.2)', color: tab === t ? C.teal : 'white' }}>{label}</button>
          ))}
          <button onClick={() => window.print()} style={{ padding: '6px 14px', borderRadius: 16, border: '1px solid rgba(255,255,255,0.4)', background: 'transparent', color: 'white', cursor: 'pointer', fontSize: 12 }}>📄 PDF</button>
        </div>
      </div>

      {/* START/END DATE BAR */}
      {profile.startDate && (
        <div className="no-print" style={{ background: 'white', borderBottom: `1px solid ${C.border}`, padding: '10px 18px', display: 'flex', gap: 12, alignItems: 'center', fontSize: 12, flexWrap: 'wrap' }}>
          <span style={{ color: C.teal }}>🚀 Start: <strong>{formatDate(profile.startDate)}</strong></span>
          <span style={{ color: '#bbb' }}>•</span>
          <span style={{ color: C.gold }}>🏁 Dag 30: <strong>{formatDate(endDate)}</strong></span>
          <span style={{ color: '#bbb', marginLeft: 'auto', fontSize: 11 }}>30-daags programma</span>
        </div>
      )}

      {/* ── WEEK PLANNER ── */}
      {tab === 'planner' && (
        <div className="no-print" style={{ maxWidth: 1300, margin: '0 auto', padding: '20px 14px' }}>
          <div style={{ background: `linear-gradient(135deg, ${C.teal} 0%, ${C.tealMid} 55%, ${C.gold} 100%)`, borderRadius: 16, padding: '18px 28px', marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
            <div>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 600, color: 'white' }}>
                "Ik ben trots op mezelf dat ik aan deze reis ben begonnen."
              </div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.8)', marginTop: 4 }}>Elke stap die jij zet, {profile.name}, telt. 🌟</div>
            </div>
            {profile.startDate && (
              <div style={{ textAlign: 'right', fontSize: 12, color: 'rgba(255,255,255,0.85)' }}>
                <div>🚀 Start: <strong>{formatDate(profile.startDate)}</strong></div>
                <div>🏁 Dag 30: <strong>{formatDate(endDate)}</strong></div>
              </div>
            )}
          </div>
          <div style={{ background: 'white', borderRadius: 12, padding: '12px 16px', marginBottom: 16, border: `1px solid ${C.border}`, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div style={{ flex: 1, minWidth: 180 }}>
              <Lbl>📅 Week van</Lbl>
              <input value={profile.weekLabel || ''} onChange={e => setProfile(p => ({ ...p, weekLabel: e.target.value }))} placeholder="bv. 24 – 30 maart 2025" style={is} />
            </div>
            <button onClick={() => setShowVastenModal(true)} style={{ background: C.goldLight, color: C.gold, border: `1px solid ${C.gold}`, borderRadius: 9, padding: '9px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>⚡ Cleanseday</button>
            <button onClick={() => window.print()} style={{ background: C.teal, color: 'white', border: 'none', borderRadius: 9, padding: '9px 18px', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>📄 PDF</button>
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px', minWidth: 950 }}>
              <thead>
                <tr>
                  {[['Dag',90],['🍓 Ontbijt',140],['🍎 10u',115],['☀️ Middag',190],['🍪 16u',115],['🌙 Avond',190],['💚 Score',105],['📝 Notities',140]].map(([label,w]) => (
                    <th key={label} style={{ width: w, padding: '4px 10px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: C.teal, textTransform: 'uppercase', letterSpacing: 0.5, border: 'none' }}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {days.map((day, i) => {
                  const isVasten = day.type === 'vasten';
                  const isBalance = profile.pakket === 'balance';
                  const accent = isVasten ? C.gold : C.teal;
                  const rowBg = isVasten ? '#fff8f0' : 'white';
                  const bc = isVasten ? '#e8c87a' : '#d4ece5';
                  const cell = { background: rowBg, border: `1.5px solid ${bc}`, borderLeft: 'none', padding: '9px 10px', verticalAlign: 'top' };

                  // Toggle component for middag/avond
                  const MomentCell = ({ momentKey, maaltijdKey, maaltijdNameKey, label }) => {
                    const isShake = day[momentKey] === 'shake';
                    const flavorKey = momentKey === 'middagType' ? 'shakeFlavor2' : 'shakeFlavor3';
                    return (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                        {/* Toggle */}
                        <div style={{ display: 'flex', borderRadius: 8, overflow: 'hidden', border: `1.5px solid ${accent}`, width: 'fit-content' }}>
                          <button onClick={() => upd(i, momentKey, 'shake')} style={{ padding: '3px 10px', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: isShake ? 700 : 400, background: isShake ? accent : 'white', color: isShake ? 'white' : accent, transition: 'all 0.15s' }}>🥤 Shake</button>
                          <button onClick={() => upd(i, momentKey, 'maaltijd')} style={{ padding: '3px 10px', border: 'none', borderLeft: `1px solid ${accent}`, cursor: 'pointer', fontSize: 11, fontWeight: !isShake ? 700 : 400, background: !isShake ? accent : 'white', color: !isShake ? 'white' : accent, transition: 'all 0.15s' }}>🍽️ Maaltijd</button>
                        </div>
                        {isShake ? (
                          <div>
                            <select value={day[flavorKey] || 'Chocolade'} onChange={e => upd(i, flavorKey, e.target.value)} style={{ ...ss, fontSize: 11, padding: '4px 6px' }}>
                              {SHAKE_FLAVORS.map(f => <option key={f}>{f}</option>)}
                            </select>
                            <div style={{ fontSize: 9, color: C.muted, marginTop: 3 }}>+ Thermo GX</div>
                          </div>
                        ) : (
                          <div>
                            {day[maaltijdNameKey] && <div style={{ fontSize: 9, color: C.gold, fontWeight: 700 }}>📌 {day[maaltijdNameKey]}</div>}
                            <div style={{ display: 'flex', gap: 3 }}>
                              <input value={day[maaltijdKey]} onChange={e => upd(i, maaltijdKey, e.target.value)} placeholder="Typ maaltijd..." style={{ ...is, fontSize: 11, padding: '4px 6px', flex: 1 }} />
                              <button onClick={() => setMealModal({ dayIndex: i, mealKey: maaltijdKey, mealNameKey: maaltijdNameKey, label: `${day.name} — ${label}` })} style={{ background: accent, color: 'white', border: 'none', borderRadius: 5, padding: '0 6px', cursor: 'pointer', fontSize: 12, flexShrink: 0 }}>🏗️</button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  };

                  return (
                    <tr key={i}>
                      {/* DAG */}
                      <td style={{ background: accent, borderRadius: '10px 0 0 10px', padding: '12px 13px', verticalAlign: 'middle' }}>
                        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 600, color: 'white' }}>{day.name}</div>
                        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)', fontWeight: 600, marginTop: 2 }}>{isVasten ? '⚡ Vasten' : '🥤 Shake'}</div>
                      </td>

                      {/* ONTBIJT */}
                      <td style={cell}>
                        {!isVasten ? (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <div style={{ fontSize: 9, color: C.muted }}>Ionix Supreme 30ml</div>
                            <select value={day.shakeFlavor1 || 'Chocolade'} onChange={e => upd(i, 'shakeFlavor1', e.target.value)} style={{ ...ss, fontSize: 11, padding: '4px 6px' }}>
                              {SHAKE_FLAVORS.map(f => <option key={f}>{f}</option>)}
                            </select>
                            <div style={{ fontSize: 9, color: C.muted }}>+ Thermo GX</div>
                            <div style={{ fontSize: 9, color: '#a07040', fontStyle: 'italic' }}>☕ Koffie mag erbij</div>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <div style={{ fontSize: 9, color: C.gold, fontWeight: 700 }}>Ionix Supreme 30ml</div>
                            <div style={{ fontSize: 9, color: C.gold, fontWeight: 700 }}>1x Thermo GX</div>
                          </div>
                        )}
                      </td>

                      {/* SNACK 10u */}
                      <td style={cell}>
                        {!isVasten
                          ? <select value={day.snack10u} onChange={e => upd(i, 'snack10u', e.target.value)} style={{ ...ss, fontSize: 11, padding: '4px 6px' }}><option>— Snack —</option>{SNACK_DATA.map(s => <option key={s.name} value={s.name}>{s.icon} {s.name}</option>)}</select>
                          : <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}><div style={{ width: 11, height: 11, border: `1.5px solid ${C.gold}`, borderRadius: 2, flexShrink: 0, marginTop: 1 }} /><span style={{ fontSize: 9 }}>Nourish for Life</span></div>
                        }
                      </td>

                      {/* MIDDAG */}
                      <td style={cell}>
                        {!isVasten
                          ? <MomentCell momentKey="middagType" maaltijdKey="maaltijd1" maaltijdNameKey="maaltijd1Name" label="Middag" />
                          : <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                              {['☀️ Middag','🌤 Namiddag'].map(t => (
                                <div key={t} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                  <div style={{ width: 11, height: 11, border: `1.5px solid ${C.gold}`, borderRadius: 2, flexShrink: 0 }} />
                                  <span style={{ fontSize: 9 }}>{t} Nourish for Life</span>
                                </div>
                              ))}
                            </div>
                        }
                      </td>

                      {/* SNACK 16u */}
                      <td style={cell}>
                        {!isVasten
                          ? <select value={day.snack16u} onChange={e => upd(i, 'snack16u', e.target.value)} style={{ ...ss, fontSize: 11, padding: '4px 6px' }}><option>— Snack —</option>{SNACK_DATA.map(s => <option key={s.name} value={s.name}>{s.icon} {s.name}</option>)}</select>
                          : <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}><div style={{ width: 11, height: 11, border: `1.5px solid ${C.gold}`, borderRadius: 2, flexShrink: 0, marginTop: 1 }} /><span style={{ fontSize: 9 }}>Nourish for Life</span></div>
                        }
                      </td>

                      {/* AVOND */}
                      <td style={cell}>
                        {!isVasten
                          ? <MomentCell momentKey="avondType" maaltijdKey="maaltijd2" maaltijdNameKey="maaltijd2Name" label="Avond" />
                          : <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <div style={{ width: 11, height: 11, border: `1.5px solid ${C.gold}`, borderRadius: 2, flexShrink: 0 }} />
                                <span style={{ fontSize: 9 }}>🌙 Avond Nourish for Life</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                <button onClick={() => upd(i, 'credits', Math.max(0, day.credits - 1))} style={{ width: 16, height: 16, borderRadius: 3, border: `1px solid ${C.border}`, background: 'white', cursor: 'pointer', fontSize: 10, lineHeight: 1 }}>−</button>
                                <span style={{ fontSize: 11, fontWeight: 700, color: day.credits >= 8 ? '#c0392b' : C.dark, minWidth: 12, textAlign: 'center' }}>{day.credits}</span>
                                <button onClick={() => upd(i, 'credits', Math.min(10, day.credits + 1))} style={{ width: 16, height: 16, borderRadius: 3, border: `1px solid ${C.border}`, background: 'white', cursor: 'pointer', fontSize: 10, lineHeight: 1 }}>+</button>
                                <span style={{ fontSize: 9, color: C.muted }}>/10 cr.</span>
                              </div>
                              <button onClick={() => setShowVastenModal(true)} style={{ fontSize: 9, color: C.gold, background: C.goldLight, border: `1px solid ${C.gold}`, borderRadius: 5, padding: '2px 6px', cursor: 'pointer', width: 'fit-content' }}>📋 Tracker</button>
                            </div>
                        }
                      </td>

                      {/* SCORE */}
                      <td style={{ ...cell, verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                          <input type="range" min={0} max={10} value={day.wellness} onChange={e => upd(i, 'wellness', Number(e.target.value))} style={{ width: 60, accentColor: wColor(day.wellness) }} />
                          <div style={{ width: 26, height: 26, borderRadius: '50%', background: day.wellness ? wColor(day.wellness) : '#ddd', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700, fontSize: 11, flexShrink: 0 }}>{day.wellness || '—'}</div>
                        </div>
                        {day.wellness > 0 && <div style={{ fontSize: 9, color: C.muted, marginTop: 2 }}>{WELLNESS_LABELS[day.wellness]}</div>}
                      </td>

                      {/* NOTITIES */}
                      <td style={{ ...cell, borderRadius: '0 10px 10px 0' }}>
                        <textarea value={day.notities} onChange={e => upd(i, 'notities', e.target.value)} placeholder="Notities..." rows={3} style={{ ...is, resize: 'none', fontSize: 11, padding: '4px 7px' }} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 12, fontSize: 11, color: C.muted, textAlign: 'center' }}>🌙 Elke dag afsluiten met 2x IsaMove capsules</div>
        </div>
      )}

      {/* ── WORKOUTS ── */}
      {tab === 'workouts' && (
        <div className="no-print" style={{ maxWidth: 860, margin: '0 auto', padding: '24px 16px' }}>
          <div style={{ background: 'linear-gradient(135deg, #e8f4f8, #f0eaf8)', borderRadius: 16, padding: '20px 24px', marginBottom: 20, border: '1px solid #d4e8f0' }}>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 600, color: '#2d6a8a' }}>💪 Workout Videos</div>
            <div style={{ fontSize: 13, color: '#5a7a8a', marginTop: 4 }}>Plak de YouTube-links van jouw workout videos. De cliënt klikt dan rechtstreeks door.</div>
          </div>
          {[1,2,3,4].map(week => (
            <div key={week} style={{ background: 'white', borderRadius: 14, marginBottom: 12, overflow: 'hidden', border: `1px solid ${C.border}` }}>
              <div style={{ padding: '12px 18px', background: '#f8f5f0', borderBottom: `1px solid ${C.border}` }}>
                <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 600, color: C.dark }}>
                  Week {week} — {['Opstarten','Opbouwen','Intensiveren','Afronden'][week-1]}
                </div>
              </div>
              <div style={{ padding: '14px 18px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                {['💪 Krachttraining A','💃 Zumba','💪 Krachttraining B','🧘 Stretch/Herstel'].map((type, j) => {
                  const key = `video_w${week}_${j}`;
                  return (
                    <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 13, fontWeight: 500, minWidth: 170, color: C.dark }}>{type}</span>
                      <input value={profile[key] || ''} onChange={e => setProfile(p => ({ ...p, [key]: e.target.value }))} placeholder="https://youtube.com/watch?v=..." style={{ ...is, flex: 1, fontSize: 12 }} />
                      {profile[key] && <a href={profile[key]} target="_blank" rel="noreferrer" style={{ background: '#ff0000', color: 'white', borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap' }}>▶ Open</a>}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
          <div style={{ background: C.tealLight, borderRadius: 12, padding: '12px 16px', fontSize: 13, color: C.teal }}>
            <strong>💡 Hoe?</strong> Ga naar YouTube → open de video → kopieer de link uit de adresbalk → plak hierboven. Zodra de link ingevuld is verschijnt een rode "▶ Open" knop voor de cliënt.
          </div>
        </div>
      )}

      {/* ── FAQ ── */}
      {tab === 'faq' && (
        <div className="no-print" style={{ maxWidth: 660, margin: '0 auto', padding: '20px 14px', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 120px)' }}>
          <div style={{ background: C.tealLight, borderRadius: 12, padding: '10px 14px', marginBottom: 10, fontSize: 13, color: C.teal }}>
            <strong>AI Programma-assistent</strong> voor {profile.name}
          </div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
            {['Mag ik koffie?','Vastendag: wat mag ik?','Hoeveel water?','Mag ik sporten?'].map(q => (
              <button key={q} onClick={() => setFaqInput(q)} style={{ padding: '5px 11px', borderRadius: 14, border: `1px solid ${C.teal}`, background: 'white', color: C.teal, fontSize: 12, cursor: 'pointer' }}>{q}</button>
            ))}
          </div>
          <div ref={chatRef} style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 10, padding: '2px 0 12px' }}>
            {faqMsgs.map((msg, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start' }}>
                <div style={{ maxWidth: '82%', padding: '10px 14px', borderRadius: msg.role === 'user' ? '16px 16px 4px 16px' : '16px 16px 16px 4px', background: msg.role === 'user' ? C.teal : 'white', color: msg.role === 'user' ? 'white' : C.dark, fontSize: 14, lineHeight: 1.55, boxShadow: '0 1px 4px rgba(0,0,0,0.07)', border: msg.role === 'assistant' ? `1px solid ${C.border}` : 'none', whiteSpace: 'pre-wrap' }}>{msg.content}</div>
              </div>
            ))}
            {faqLoading && <div style={{ display: 'flex' }}><div style={{ padding: '12px', background: 'white', borderRadius: '16px 16px 16px 4px', border: `1px solid ${C.border}` }}>⏳</div></div>}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input value={faqInput} onChange={e => setFaqInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && sendFaq()} placeholder="Stel een vraag..." style={{ ...is, flex: 1 }} />
            <button onClick={sendFaq} disabled={faqLoading || !faqInput.trim()} style={{ background: C.teal, color: 'white', border: 'none', borderRadius: 10, padding: '0 18px', cursor: 'pointer', fontSize: 18, opacity: faqLoading || !faqInput.trim() ? 0.5 : 1 }}>→</button>
          </div>
          <div style={{ fontSize: 11, color: C.muted, textAlign: 'center', marginTop: 6 }}>
            <a href="https://wa.me/32491486550" style={{ color: C.teal }}>Contacteer Sarah via WhatsApp</a>
          </div>
        </div>
      )}
    </div>
  );
}
